import { getUserInfo, getUserProfile } from 'app/selectors';

import { useSelector } from 'react-redux';

import Styles from './Profile.module.css';

const rolesMap = {
    NTCAdministrator: 'Администратор НТЦ',
    IBAdministrator: 'Администратор ИБ',
    DOAdministrator: 'Администратор ДО',
    OCExpert: 'Эксперт ОЦ',
    OCUser: 'ОЦ',
    UKSUser: 'УКС',
    OKUser: 'ОК',
    SMRContractor: 'Подрядчик СМР',
};

export const Profile = () => {
    const profileInfo = useSelector(getUserProfile) as { roles: string[]; username: string };
    const userInfo = useSelector(getUserInfo) as { company: string };

    return (
        <main>
            <h2 className={Styles.title}>Профиль пользователя</h2>
            <section className={Styles.container}>
                <div className={Styles.wrapperData}>
                    <p className={Styles.subTitle}>Данные</p>
                    <ul className={Styles.profileList}>
                        <li>
                            <span>Имя пользователя/Логин</span>
                            <div>{profileInfo?.username}</div>
                        </li>
                        <li>
                            <span>Название компании</span>
                            <div>{userInfo?.company}</div>
                        </li>
                    </ul>
                </div>
                <div>
                    <p className={Styles.subTitle}>Роли</p>
                    <ul className={Styles.profileList}>
                        {Object.entries(rolesMap).map(([codeName, displayName]) => (
                            <li key={codeName} className={profileInfo?.roles?.includes(codeName) ? 'bold' : ''}>
                                {displayName}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>
        </main>
    );
};

Profile.displayName = 'Profile';
